import { uploadRFQFiles } from "@hardware/Services/FileUploadService";
import { PENDING_SUBMIT_QUOTE_KEY } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { CustomState } from "@hardware/Store/Reducers";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateOrRequestQuote,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

addToChainBefore(chain, CreateOrRequestQuote, async props => {
    const state = props.getState() as CustomState;
    const form = new FormData();
    try {
        if (state.rfqFileUpload.files.length > 0) {
            let count = 0;
            state.rfqFileUpload.files.forEach(file => {
                form.append("file", file.file);
                form.append(`fileLine${count++}`, file.line);
            });
        } else if (state.rfqFileUpload.files.length === 0) {
            return;
        }

        const apiResult: string = await uploadRFQFiles(form);

        if (apiResult.toLocaleLowerCase() === "success") {
            // eslint-disable-next-line no-console
            console.log("Files upload successful");
            props.dispatch({
                type: "Custom/RFQFileUpload/ClearFiles",
            } as any);
        }
    } catch (error) {
        if ("errorMessage" in error) {
            // eslint-disable-next-line no-console
            console.log("Files upload failed", error.errorMessage);
        }

        return false;
    }
});

// Verndale Customization - mark successful RFQ submit for GA4 submit_quote on confirmation
addToChainAfter(chain, CreateOrRequestQuote, props => {
    if (IS_SERVER_SIDE || !props.apiResult?.id) {
        return;
    }

    sessionStorage.setItem(PENDING_SUBMIT_QUOTE_KEY, props.apiResult.id);
});
